import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SliderComponent } from './components/slider/slider.component';

export * from './models/slider-value';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SliderComponent,
  ],
  exports: [
    SliderComponent
  ]
})
export class McRAISliderModule { }
